// Copyright (c) 2024 WiseTime. All rights reserved.

import { useEffect, useState } from "react"
import { useWindowSize as _useWindowSize } from "react-use"
import { isIosWiseTime } from "./config"

// iOS app doesn't support well window.innerWidth/innerHeight that are returned from "react-use" useWindowSize hook,
// so we need to use screen.width/height which fits for mobile devices
export const useWindowSize = (): { width: number, height: number } => {
  const windowSize = _useWindowSize()

  const [screenSize, setScreenWidth] = useState({ width: screen.width, height: screen.height })
  useEffect(() => {
    const resize = () => {
      setScreenWidth({ width: screen.width, height: screen.height })
    }

    window.addEventListener("resize", resize)

    return () => {
      window.removeEventListener("resize", resize)
    }
  }, [])

  return isIosWiseTime ? screenSize : windowSize
}
